import { render, staticRenderFns } from "./ActivityPreview.vue?vue&type=template&id=1f53a542&scoped=true&"
import script from "./ActivityPreview.vue?vue&type=script&lang=js&"
export * from "./ActivityPreview.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPreview.vue?vue&type=style&index=0&id=1f53a542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53a542",
  null
  
)

export default component.exports